/**
 * UpgradeCTA — teal button/banner that routes to the server-rendered /pricing
 * page.
 *
 * CERT-FIX-1 Part 6 (closes the BACKLOG "Upgrade plan SPA navigation" entry):
 * /pricing is an Express EJS marketing page, NOT an SPA route — the previous
 * onClick handler intercepted the click (preventDefault + SPA navigate) and
 * dead-ended in the client router, which has no /pricing route (the recorded
 * SPA-vs-Express collision). The fix is to NOT intercept: the plain <a>
 * performs a full browser navigation to the server page. `navigate` remains
 * in the signature so existing call sites need no change; it is deliberately
 * unused.
 */
export function UpgradeCTA({ label = 'Upgrade', variant = 'button', navigate: _navigate }) {
  const className =
    variant === 'banner' ? 'upgrade-cta upgrade-cta-banner' : 'upgrade-cta upgrade-cta-button';
  return (
    <a
      href="/pricing"
      className={className}
      role="button"
      aria-label={label}
    >
      {label}
    </a>
  );
}
